// 3rd party libraries imports
import { Directive, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';

@Directive({})
export abstract class OnDestroyNewHookDirective implements OnDestroy {
  unsub$ = new Subject<void>();

  ngOnDestroy() {
    this.unsub$.next();
    this.unsub$.complete();
  }
}
